/**
 * @generated SignedSource<<d81102cb9b9fe7f2efc4d8d1316319b7>>
 * @relayHash 65f308f398f07a52526dffa7fc35649f
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 65f308f398f07a52526dffa7fc35649f

import type { ConcreteRequest } from 'relay-runtime';
export type AddBlockedByInput = {
  blockingIssueId: string;
  clientMutationId?: string | null | undefined;
  issueId: string;
};
export type createIssueAddBlockedByMutation$variables = {
  input: AddBlockedByInput;
};
export type createIssueAddBlockedByMutation$data = {
  readonly addBlockedBy: {
    readonly blockingIssue: {
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly issue: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type createIssueAddBlockedByMutation$rawResponse = {
  readonly addBlockedBy: {
    readonly blockingIssue: {
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }>;
    readonly issue: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type createIssueAddBlockedByMutation = {
  rawResponse: createIssueAddBlockedByMutation$rawResponse;
  response: createIssueAddBlockedByMutation$data;
  variables: createIssueAddBlockedByMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "blockingIssue",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createIssueAddBlockedByMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddBlockedByPayload",
        "kind": "LinkedField",
        "name": "addBlockedBy",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createIssueAddBlockedByMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddBlockedByPayload",
        "kind": "LinkedField",
        "name": "addBlockedBy",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "65f308f398f07a52526dffa7fc35649f",
    "metadata": {},
    "name": "createIssueAddBlockedByMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7f30bb2691dc4eafbbc4a54660557dc1";

export default node;
